// extracted by mini-css-extract-plugin
module.exports = {"bell_icon":"Approval_bell_icon__l-7Rn","margin_right_4":"Approval_margin_right_4__vNVrW","margin_right_8":"Approval_margin_right_8__uMD4C"};